/**
 * Extrae el mensaje de error de la respuesta del backend.
 * Soporta strings simples, strings con razón al final (ej. Error: razón) y arrays de strings (class-validator).
 */
export const extractErrorMessage = (error: any): string => {
  const messageData = error?.response?.data?.message;
  if (Array.isArray(messageData)) return messageData.join(', ');
  if (typeof messageData === 'string') return messageData.split(':').at(-1) || error.message;
  return error?.message || 'Ocurrió un error inesperado';
};
